import type { TranslationSyncDTO } from '../service/ai-translation.repository.interface';
import type { TaskInfo } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { TranslationSync } from '@/infrastructure/api-functions/interface/translation-sync.interface';

@injectable()
export class TranslationSyncDTOImpl implements TranslationSyncDTO {
    constructor(
        @inject(TranslationSync)
        private readonly _translationSyncApi: TranslationSync,
    ) { }

    async fetch(value: TaskInfo): Promise<void> {
        const params = {
            current_step: value.currentStep,
            task_id: value.taskId,
        };
        await this._translationSyncApi.translationSync(params);
    }
}
